/* eslint-disable no-console */
import PropTypes from 'prop-types'

import {useEffect} from 'react'
import {withRouter} from 'react-router'

import FuneralHomeClientSummariesTable from '../../shared_components/FuneralHomeClientSummariesTable'
import routerUtils from '../../../../../lib/routerUtils'

import {useClientSummariesTableData, useFuneralHomeClientSummariesTableState} from '../../../../../lib/hooks'
import {capitalize} from '../../../../../lib/tools'
import {webAppsUrl} from '../../../../../lib/urlTools'

export const FuneralHomeClientSummariesTableContainer = props => {
  const {
    clientSummaries,
    fetchClientSummaries,
    isFiltering,
    loading,
    pages,
    recordCount,
    checkboxFilterOptions
  } = useClientSummariesTableData(props.readEndpoint)

  const {
    filtered,
    handleFilteredChange,
    handlePageSizeChange,
    handleSortedChange,
    page,
    pageSize,
    setFiltered,
    setPage,
    sorted
  } = useFuneralHomeClientSummariesTableState(fetchClientSummaries)

  const statusFilter = status => (
    status && status !== 'all' ?
      [{id: 'status', value: capitalize(status)}] :
      []
  )
  useEffect(() => {
    if (props.location.query.status) {
      setFiltered(statusFilter(props.location.query.status))
      setPage(0)

      routerUtils.push('pro/clients')
    }
  }, [props.location.query.status])

  const handleRowClick = clientSeatId => {
    window.open(
      webAppsUrl(`pro/household/${clientSeatId}`), '_blank'
    ).focus()
  }

  return (
    <div className='funeral-home-client-summaries-table-container'>
      <FuneralHomeClientSummariesTable
        checkboxFilterOptions={checkboxFilterOptions}
        clientSummaries={clientSummaries}
        filtered={filtered}
        isFiltering={isFiltering}
        loading={loading}
        onFetchData={fetchClientSummaries}
        onFilteredChange={newFilters => handleFilteredChange(newFilters)}
        onPageChange={newPage => setPage(newPage)}
        onPageSizeChange={newPageSize => handlePageSizeChange(newPageSize)}
        onRowClick={handleRowClick}
        onSortedChange={newSorted => handleSortedChange(newSorted)}
        page={page}
        pageSize={pageSize}
        pages={pages}
        recordCount={recordCount}
        sorted={sorted}
      />
    </div>
  )
}

FuneralHomeClientSummariesTableContainer.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.shape({
      status: PropTypes.string
    })
  }),
  readEndpoint: PropTypes.func.isRequired
}

export default withRouter(FuneralHomeClientSummariesTableContainer)
